import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Plural, Trans } from "@lingui/react/macro"
import { Button } from "@mantine/core"
import { identityInkColor } from "../../lib/speaker-colors"
import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

function firstName(name: string): string {
  const word = name.trim().split(/\s+/)[0]
  return word ?? name
}

/**
 * One-line cue for speakers who still need a name, or a small avatar row once
 * everyone is named. Dumb: props in, the Name button out. Not mounted yet.
 */
export function SpeakerNamingStrip({
  unnamedCount,
  firstUnnamedLabel,
  firstUnnamedShare,
  people,
  onNameClick,
}: IProps): React.JSX.Element | null {
  const { i18n } = useLingui()

  if (unnamedCount <= 0 && people.length === 0) return null

  if (unnamedCount > 0) {
    const percent = firstUnnamedShare != null ? Math.round(firstUnnamedShare * 100) : null
    const detail =
      firstUnnamedLabel && percent != null
        ? i18n._(msg`${firstUnnamedLabel} · ${percent}% of the talking`)
        : (firstUnnamedLabel ?? "")
    return (
      <div className={classes.strip} data-testid="speaker-naming-strip">
        <div className={classes.copy}>
          <p className={classes.title}>
            <Plural value={unnamedCount} one="# speaker needs a name" other="# speakers need a name" />
          </p>
          {detail.length > 0 ? <p className={classes.sub}>{detail}</p> : null}
        </div>
        <Button size="compact-sm" onClick={onNameClick}>
          <Trans>Name</Trans>
        </Button>
      </div>
    )
  }

  return (
    <ul className={classes.people} data-testid="speaker-naming-strip">
      {people.map((person) => (
        <li key={person.key} className={classes.person}>
          <span
            className={classes.avatar}
            style={{ background: person.color, color: identityInkColor(person.color) }}
            aria-hidden
          >
            {person.initials}
          </span>
          <span className={classes.personName}>{firstName(person.name)}</span>
        </li>
      ))}
    </ul>
  )
}
